import React, { useState } from "react";
import CustomModel from "./customModel";
import { category } from "../../constants/category";
import Icon from "./icon";

const inputClass =
  "w-full px-4 py-3 bg-gray-50 rounded-xl border border-purple-200 outline-none text-sm text-gray-900 focus:border-primary";

function FilterPopup(props) {
  const { open, onClose, setDate, date, type, setType } = props;
  const [newDate, setNewDate] = useState(date.toISOString().split("T")[0]);

  const handleSave = () => {
    onClose();
  };

  const handleClose = () => {
    setDate(new Date());
    onClose();
  };

  const handleDate = (e) => {
    setNewDate(e.target.value);
    setDate(new Date(e.target.value));
  };

  const handleType = (e) => {
    setType(e.target.value);
  };

  return (
    <CustomModel
      showCloseIcon={true}
      open={open}
      onClose={onClose}
      className="bg-white rounded-3xl"
    >
      <div className="py-2">
        <h2 className="text-lg font-semibold text-gray-900 text-center mb-4">
          Filter
        </h2>
        <div className="flex flex-col gap-3">
          <div>
            <label className="text-xs font-medium text-gray-500 mb-1 block">
              Date
            </label>
            <input
              type="date"
              className={inputClass}
              onChange={handleDate}
              value={newDate}
            />
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500 mb-2 block">
              Category
            </label>
            <div className="flex items-center gap-2 flex-wrap">
              {category.map((cate) => (
                <label
                  key={cate.value}
                  className={`flex flex-col items-center px-3 py-2 rounded-xl cursor-pointer ${
                    type === cate.value
                      ? "bg-primary-bg border border-primary"
                      : "bg-gray-50 border border-transparent"
                  }`}
                >
                  <input
                    type="radio"
                    name="category"
                    value={cate.value}
                    checked={type === cate.value}
                    onChange={handleType}
                    className="sr-only"
                  />
                  <Icon
                    className={
                      type === cate.value ? "text-primary" : "text-gray-400"
                    }
                    icon={cate.icon}
                  />
                  <span
                    className={`text-xs mt-1 ${
                      type === cate.value
                        ? "text-primary font-medium"
                        : "text-gray-500"
                    }`}
                  >
                    {cate.name}
                  </span>
                </label>
              ))}
              <label
                className={`flex flex-col items-center px-3 py-2 rounded-xl cursor-pointer ${
                  type === "all"
                    ? "bg-primary-bg border border-primary"
                    : "bg-gray-50 border border-transparent"
                }`}
              >
                <input
                  type="radio"
                  name="category"
                  value="all"
                  checked={type === "all"}
                  onChange={handleType}
                  className="sr-only"
                />
                <span className="text-xs text-gray-500">All</span>
              </label>
            </div>
          </div>
        </div>
        <div className="flex gap-3 mt-5">
          <button
            onClick={handleSave}
            className="flex-1 py-3 bg-primary hover:bg-primary-light rounded-xl text-white font-semibold text-sm"
          >
            Apply
          </button>
          <button
            onClick={handleClose}
            className="flex-1 py-3 bg-white border border-gray-200 rounded-xl text-gray-700 font-semibold text-sm hover:bg-gray-50"
          >
            Reset
          </button>
        </div>
      </div>
    </CustomModel>
  );
}

export default FilterPopup;
